import { SET_LANGUAGE } from "./Types";

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
});
